<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc" role="doc-toc">
<h1 id="toc-title">The King’s Chameleon</h1>
<ol class="toc">
<li>
<span href="#/text/cover" title="Link target outside of Sample">Cover</span>
</li>
<li id="title_page">
<a href="#/text/title_page">Title Page</a>
</li>
<li id="toc-li-1">
<a href="#/text/ch001#disclaimer">Disclaimer</a>
</li>
<li id="toc-li-2">
<a href="#/text/ch002#epigraph">Epigraph</a>
</li>
<li id="toc-li-3">
<a href="#/text/ch003#tumbledown-dick">Tumbledown Dick</a>
<ol class="toc">
<li id="toc-li-4">
<a href="#/text/ch003#may-1659">May 1659</a>
</li>
</ol>
</li>
<li id="toc-li-5">
<a href="#/text/ch004#part-one">Part One</a>
<ol class="toc">
<li id="toc-li-6">
<a href="#/text/ch004#restoration">Restoration</a>
<ol class="toc">
<li id="toc-li-7">
<a href="#/text/ch004#section">1660–1662</a>
</li>
</ol>
</li>
</ol>
</li>
<li id="toc-li-8">
<a href="#/text/ch005#honest-george">Honest George</a>
<ol class="toc">
<li id="toc-li-9">
<a href="#/text/ch005#februarymay-1660">February–May 1660</a>
</li>
</ol>
</li>
<li id="toc-li-10">
<span href="#/text/ch006#indemnity-and-oblivion" title="Link target outside of Sample">Indemnity and Oblivion</span>
<ol class="toc">
<li id="toc-li-11">
<span href="#/text/ch006#june-1660may-1661" title="Link target outside of Sample">June 1660–May 1661</span>
</li>
</ol>
</li>
<li id="toc-li-12">
<span href="#/text/ch007#katherine-villiers" title="Link target outside of Sample">Katherine Villiers</span>
<ol class="toc">
<li id="toc-li-13">
<span href="#/text/ch007#may-1661" title="Link target outside of Sample">May 1661</span>
</li>
</ol>
</li>
<li id="toc-li-14">
<span href="#/text/ch008#the-chase" title="Link target outside of Sample">The Chase</span>
<ol class="toc">
<li id="toc-li-15">
<span href="#/text/ch008#junejuly-1661" title="Link target outside of Sample">June–July 1661</span>
</li>
</ol>
</li>
<li id="toc-li-16">
<span href="#/text/ch009#the-launching" title="Link target outside of Sample">The Launching</span>
<ol class="toc">
<li id="toc-li-17">
<span href="#/text/ch009#august-1661february-1662" title="Link target outside of Sample">August 1661–February 1662</span>
</li>
</ol>
</li>
<li id="toc-li-18">
<span href="#/text/ch010#part-two" title="Link target outside of Sample">Part Two</span>
<ol class="toc">
<li id="toc-li-19">
<span href="#/text/ch010#contagion" title="Link target outside of Sample">Contagion</span>
<ol class="toc">
<li id="toc-li-20">
<span href="#/text/ch010#section-1" title="Link target outside of Sample">1662–1666</span>
</li>
</ol>
</li>
</ol>
</li>
<li id="toc-li-21">
<span href="#/text/ch011#on-his-majestys-secret-service" title="Link target outside of Sample">On His Majesty’s Secret Service</span>
<ol class="toc">
<li id="toc-li-22">
<span href="#/text/ch011#march-1662" title="Link target outside of Sample">March 1662</span>
</li>
</ol>
</li>
<li id="toc-li-23">
<span href="#/text/ch012#the-birds-caged" title="Link target outside of Sample">The Birds Caged</span>
<ol class="toc">
<li id="toc-li-24">
<span href="#/text/ch012#march-1662-1" title="Link target outside of Sample">March 1662</span>
</li>
</ol>
</li>
<li id="toc-li-25">
<span href="#/text/ch013#rendition" title="Link target outside of Sample">Rendition</span>
<ol class="toc">
<li id="toc-li-26">
<span href="#/text/ch013#march-1662-2" title="Link target outside of Sample">March 1662</span>
</li>
</ol>
</li>
<li id="toc-li-27">
<span href="#/text/ch014#the-home-coming" title="Link target outside of Sample">The Home-Coming</span>
<ol class="toc">
<li id="toc-li-28">
<span href="#/text/ch014#march-1662-3" title="Link target outside of Sample">March 1662</span>
</li>
</ol>
</li>
<li id="toc-li-29">
<span href="#/text/ch015#the-deodand" title="Link target outside of Sample">The Deodand</span>
<ol class="toc">
<li id="toc-li-30">
<span href="#/text/ch015#april-1662september-1664" title="Link target outside of Sample">April 1662–September 1664</span>
</li>
</ol>
</li>
<li id="toc-li-31">
<span href="#/text/ch016#the-plague" title="Link target outside of Sample">The Plague</span>
<ol class="toc">
<li id="toc-li-32">
<span href="#/text/ch016#october-1664april-1666" title="Link target outside of Sample">October 1664–April 1666</span>
</li>
</ol>
</li>
<li id="toc-li-33">
<span href="#/text/ch017#part-three" title="Link target outside of Sample">Part Three</span>
<ol class="toc">
<li id="toc-li-34">
<span href="#/text/ch017#conflagration" title="Link target outside of Sample">Conflagration</span>
<ol class="toc">
<li id="toc-li-35">
<span href="#/text/ch017#section-2" title="Link target outside of Sample">1666–1667</span>
</li>
</ol>
</li>
</ol>
</li>
<li id="toc-li-36">
<span href="#/text/ch018#battle" title="Link target outside of Sample">Battle</span>
<ol class="toc">
<li id="toc-li-37">
<span href="#/text/ch018#mayjuly-1666" title="Link target outside of Sample">May–July 1666</span>
</li>
</ol>
</li>
<li id="toc-li-38">
<span href="#/text/ch019#holmess-bonfire" title="Link target outside of Sample">Holmes’s Bonfire</span>
<ol class="toc">
<li id="toc-li-39">
<span href="#/text/ch019#julyoctober-1666" title="Link target outside of Sample">July–October 1666</span>
</li>
</ol>
</li>
<li id="toc-li-40">
<span href="#/text/ch020#the-triangle" title="Link target outside of Sample">The Triangle</span>
<ol class="toc">
<li id="toc-li-41">
<span href="#/text/ch020#october-1666may-1667" title="Link target outside of Sample">October 1666–May 1667</span>
</li>
</ol>
</li>
<li id="toc-li-42">
<span href="#/text/ch021#disaster-and-disgrace" title="Link target outside of Sample">Disaster and Disgrace</span>
<ol class="toc">
<li id="toc-li-43">
<span href="#/text/ch021#june-1667" title="Link target outside of Sample">June 1667</span>
</li>
</ol>
</li>
<li id="toc-li-44">
<span href="#/text/ch022#part-four" title="Link target outside of Sample">Part Four</span>
<ol class="toc">
<li id="toc-li-45">
<span href="#/text/ch022#redemption" title="Link target outside of Sample">Redemption</span>
<ol class="toc">
<li id="toc-li-46">
<span href="#/text/ch022#section-3" title="Link target outside of Sample">1667–1672</span>
</li>
</ol>
</li>
</ol>
</li>
<li id="toc-li-47">
<span href="#/text/ch023#rupert" title="Link target outside of Sample">Rupert</span>
<ol class="toc">
<li id="toc-li-48">
<span href="#/text/ch023#june-1667january-1670" title="Link target outside of Sample">June 1667–January 1670</span>
</li>
</ol>
</li>
<li id="toc-li-49">
<span href="#/text/ch024#the-kings-chameleon" title="Link target outside of Sample">The King’s Chameleon</span>
<ol class="toc">
<li id="toc-li-50">
<span href="#/text/ch024#january-1670august-1672" title="Link target outside of Sample">January 1670–August 1672</span>
</li>
</ol>
</li>
<li id="toc-li-51">
<span href="#/text/ch025#destiny" title="Link target outside of Sample">Destiny</span>
<ol class="toc">
<li id="toc-li-52">
<span href="#/text/ch025#august-1672august-1673" title="Link target outside of Sample">August 1672–August 1673</span>
</li>
</ol>
</li>
<li id="toc-li-53">
<span href="#/text/ch026#authors-note" title="Link target outside of Sample">Author’s Note</span>
</li>
<li id="toc-li-54">
<span href="#/text/ch027#kit-faulkner-naval-adventures" title="Link target outside of Sample">Kit Faulkner Naval Adventures</span>
</li>
<li id="toc-li-55">
<span href="#/text/ch028#copyright" title="Link target outside of Sample">Copyright</span>
</li>
</ol>
</nav>
<nav epub:type="landmarks" hidden="hidden" id="landmarks">
<ol>
<li>
<span epub:type="cover" href="#/text/cover" title="Link target outside of Sample">Cover</span>
</li>
<li>
<a epub:type="toc" href="#/nav#toc">Table of Contents</a>
</li>
<li>
<a epub:type="bodymatter" href="#/text/title_page">Start of Content</a>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?34785c06